export default function sortByKey(key: string) {
  return (a: any, b: any) => (a[key] ?? 0) - (b[key] ?? 0);
}
